import React from "react";
import { Experience, Package, PurchaseRule } from "types";
import { PackageExperienceAddOnDiscountList } from "@/components/Product/Packages/PackageExperienceAddOnDiscountList";
import { PackageExperienceDemographicDiscountList } from "@/components/Product/Packages/PackageExperienceDemographicDiscountList";
import { DiscountPricingValue } from "@/components/Product/Packages/PricingSelectorHelper";
import { getSelectedExperiencesByIds } from "@/models/Experience";
import { getProductIdsInPackage } from "@/models/Package";
import { getPurchaseRuleForExperience } from "@/models/PurchaseRule";

interface AdvancedTermProps {
    pkg: Package;
    experiences: Experience[];
    purchaseRules: PurchaseRule[];
    onChangeDemographicDiscount: (discountPricingValues: DiscountPricingValue[], experience: Experience) => void;
    onChangeAddOnDiscount: (
        discountPricingValues: DiscountPricingValue[],
        experience: Experience,
        isEnabled?: boolean,
    ) => void;
}

export const AdvancedTerm = ({
    pkg,
    experiences,
    purchaseRules,
    onChangeDemographicDiscount,
    onChangeAddOnDiscount,
}: AdvancedTermProps) => {
    const selectedExperienceIds: ID[] = getProductIdsInPackage(pkg);
    const selectedExperiences = getSelectedExperiencesByIds(selectedExperienceIds, experiences);

    return (
        <>
            {selectedExperiences.map((experience) => (
                <div key={experience.id}>
                    <PackageExperienceDemographicDiscountList
                        pkg={pkg}
                        experience={experience}
                        purchaseRule={getPurchaseRuleForExperience(purchaseRules, experience.id)}
                        onChangeDemographicDiscount={(discountPricingValues: DiscountPricingValue[]) =>
                            onChangeDemographicDiscount(discountPricingValues, experience)
                        }
                    />

                    <PackageExperienceAddOnDiscountList
                        experience={experience}
                        purchaseRule={getPurchaseRuleForExperience(purchaseRules, experience.id)}
                        onChangeAddOnDiscount={(discountPricingValue: DiscountPricingValue[], isEnabled) =>
                            onChangeAddOnDiscount(discountPricingValue, experience, isEnabled)
                        }
                    />
                </div>
            ))}
        </>
    );
};
